'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ScrollableOrientationShape = {};

exports.__exports = ScrollableOrientationShape;
